<div class="course-wrapper pt-2">
  <mat-card>
    <ng-container *ngIf="!course.billing">
    <app-ribbon></app-ribbon>
    </ng-container>
    <mat-card-content>
      <a class="txt-deco-none" [routerLink]="['/courses', course.$key]">
        <img mat-card-image *ngIf="course.coverUrl" [src]="course.coverUrl" class="h-100">
        <mat-card-title>{{ course.name }}</mat-card-title>
      </a>
      <img mat-card-avatar [src]="(course.ownerObservable | async)?.avatarUrl" class="rounded-circle">
      <span class="ml-2">{{ (course.ownerObservable | async)?.name }}</span>
      <app-course-edit-button [course]="course" *appAuthorize="course.owner" class="float-right">
        <button mat-icon-button class="float-right">
          <mat-icon>edit</mat-icon>
        </button>
      </app-course-edit-button>
      <app-course-enrollment-status *appAuthorize="'!'+course.owner" [course]="course">
        <ng-container not-enrolled>
          <app-course-enroll-button [course]="course" class="float-right">
            <button mat-icon-button>
              <mat-icon>person_add</mat-icon>
            </button>
          </app-course-enroll-button>
        </ng-container>
        <ng-container not-approved>
          <button mat-icon-button disabled class="float-right">
            <mat-icon>person_add</mat-icon>
          </button>
        </ng-container>
      </app-course-enrollment-status>
    </mat-card-content>
  </mat-card>
</div>




// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course/course.component.html